export function isFeedbackTestHookEnabled(key, options = {}) {
  const env = options.env || import.meta.env || {};
  if (!(env.DEV || env.VITE_E2E === 'true' || env.VITE_E2E === true)) return false;
  const storage =
    options.storage || (typeof window !== 'undefined' ? window.localStorage : undefined);
  if (!storage) return false;
  try {
    return storage.getItem(key) === 'true';
  } catch {
    return false;
  }
}
